/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The speech to text provider to use for real-time streaming transcription. Supported providers: 'gladia', 'deepgram', 'assemblyai', 'speechmatics', 'soniox', 'elevenlabs'.
 */
export type UpdateScheduledBotRequestBodyStreamingConfigAnyOfTranscriptionAnyOfProvider =
  (typeof UpdateScheduledBotRequestBodyStreamingConfigAnyOfTranscriptionAnyOfProvider)[keyof typeof UpdateScheduledBotRequestBodyStreamingConfigAnyOfTranscriptionAnyOfProvider]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateScheduledBotRequestBodyStreamingConfigAnyOfTranscriptionAnyOfProvider = {
  gladia: "gladia",
  deepgram: "deepgram",
  assemblyai: "assemblyai",
  speechmatics: "speechmatics",
  soniox: "soniox",
  elevenlabs: "elevenlabs"
} as const
